const config = require('./config.yaml');
const CMenu = require('../../index.js');

/**
 * Реализует логику варианта horizontal компонента menu
 */
class CMenu_horizontal extends CMenu {
	constructor() {
		super();
		this.config = config;
		// Тип меню для определения класса
		this.menuType = 'top';
		// Имя варианта для создания глобальных событий
		this.eventNameVariantPart = 'Horizontal';
	}

	/**
	 * Инициализация
	 */
	init() {
		// Меню
		this.$menu = $('.js-top-nav--horizontal');

		// Если меню на странице существует
		if (this.$menu.length) {
			// Все элементы ссылок в меню
			this.$links = this.$menu.find('.js-top-link');
			// Все ссылки с подменю
			this.$linksWithSub = this.$menu.find('.has-submenu > .js-top-link');
			// Класс списков (выпадашек)
			this.listClass = '.js-top-list';

			// Установить события, на которые раскрывать / закрывать списки меню
			this.setOpenHideEvents();
			// Установить ширину выпадашкам
			this.setSubListWidth();
			// По установленному событию на ссылки с подменю инициализировать раскрытие
			this.$linksWithSub.on(this.openEvents, $.proxy(this, 'onOpen'));

			// Если меню необходимо делать фиксируемым
			if (this.config.fixedMenu) {
				// Инициализировать наблюдателя состояния фиксирующегося меню
				this.initFixMenuWatcher();
			}
		}
	}

	/**
	 * Установка ширины выпадашек
	 */
	setSubListWidth() {
		this.$menu
			.find('.js-top-list-lvl2')
			.css('width', `${100 * this.config.colspanSecondLevel}%`);
	}

	/**
	 * Получение эффекта и продолжительности анимации раскрытия
	 * @param  {Object} $element Элемент пункт
	 * @return {Object}          Эффект и время анимации
	 */
	getOpenAnimation($element) {
		// Если пункт первого уровня
		if ($element.hasClass('js-top-link-lvl1')) {
			return {
				openEffect: this.config.animation.main.open.transition,
				openDuration: this.config.animation.main.open.duration
			};
		} else if ($element.siblings('.is-slide-left').length) { // Иначе если нужно выводить влево
			return {
				openEffect: this.config.animation.inner.open.toRight.transition,
				openDuration: this.config.animation.inner.open.toRight.duration
			};
		} else {
			return {
				openEffect: this.config.animation.inner.open.toLeft.transition,
				openDuration: this.config.animation.inner.open.toLeft.duration
			};
		}
	}

	/**
	 * Получение эффекта и продолжительности анимации закрытия
	 * @param  {Object}  $element     Элемент пункт
	 * @param  {Boolean} closeForNext Делается ли закрытие списка перед открытием следующего
	 * @return {Object}               Эффект и время анимации
	 */
	getCloseAnimation($element, closeForNext) {
		// Если нужно делать закрытие перед открытием следующего и элемент второго уровня
		if (closeForNext && $element.hasClass('js-top-link-lvl2')) {
			return {
				closeEffect: this.config.animation.inner.close.transition,
				closeDuration: this.config.animation.inner.close.duration
			};
		} else {
			return {
				closeEffect: this.config.animation.main.close.transition,
				closeDuration: this.config.animation.main.close.duration
			};
		}
	}

	/**
	 * Обработчик события клика / тапа / наведения курсора на документ
	 * Создаем свой обработчик вместо унаследованного,
	 * иначае при нахождении на странице нескольких вариантов, которые также унаследовали метод
	 * и для одного из них сделать $.off(), то для всех остальных также отключаюется, т.е наследуют
	 * @param  {Object} event Событие
	 */
	onDocumentListener(event) {
		// Обращаемся к родительскому методу
		super.onDocumentListener(event);
	}
}

AR.waitComponents([], () => {
	const cMenu_horizontal = new CMenu_horizontal();
	// Вызов метода, инициализирующего все существующие события
	cMenu_horizontal.init();
	// Добавление в глобальный объект AR.components
	AR.pushComponent(cMenu_horizontal, 'cMenu_horizontal');
});



// WEBPACK FOOTER //
// ./temp/components/menu/.variant/horizontal/index.js